import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconProductImport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 98,
	height: 116,
	viewBox: "0 0 98 116",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9316 99.3783H84.3001V24.6732",
			stroke: "#4D4540",
			strokeWidth: 2.74147,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.37073,
			y: 23.3025,
			width: 15.0781,
			height: 76.7611,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21.9318,
			y: 26.5269,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42.4928,
			y: 26.5269,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 63.0538,
			y: 26.5269,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21.9318,
			y: 38.122,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42.4928,
			y: 38.122,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 63.0538,
			y: 38.122,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21.9318,
			y: 49.7172,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42.4928,
			y: 49.7172,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 63.0538,
			y: 49.7172,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21.9318,
			y: 61.3123,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21.9318,
			y: 72.9075,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21.9318,
			y: 84.5026,
			width: 15.0781,
			height: 6.85367,
			rx: 1.37073,
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84.9855,
			y: 1.37073,
			width: 16.4488,
			height: 83.6148,
			rx: 1.37073,
			transform: "rotate(90 84.9855 1.37073)",
			stroke: "#4D4540",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.2153 65.11L65.2622 65.111C66.7837 65.1523 68.2826 65.4916 69.6733 66.11L69.6724 66.111C70.8576 66.588 71.957 67.2527 72.9243 68.0846L73.3491 68.4684L73.3804 68.4977L73.4106 68.5289L90.9487 86.0387L92.4058 87.483C92.9661 88.0387 93.4257 88.687 93.7642 89.3981L93.9009 89.7067L94.0239 90.0211C94.2905 90.7621 94.4272 91.5445 94.4272 92.3336H94.4253C94.4293 93.1225 94.2953 93.9051 94.0269 94.6451L93.9019 94.9635C93.7656 95.2863 93.6035 95.5971 93.4194 95.8932V98.191L92.3931 97.1656L79.3247 110.235C78.0587 111.507 76.343 112.228 74.5483 112.245L74.5493 112.246C74.548 112.246 74.5467 112.245 74.5454 112.245L74.5444 112.246L74.5435 112.245C73.745 112.252 72.9525 112.118 72.2036 111.846L71.8843 111.721C71.0645 111.375 70.3228 110.868 69.7017 110.232V110.233L50.7085 91.1998L50.6968 91.1871L50.6851 91.1754C49.6205 90.0876 48.7856 88.7959 48.231 87.3785L48.2319 87.3776C47.6529 86.0273 47.3311 84.5805 47.2915 83.111L47.2905 83.0641V71.941H47.2915C47.2862 71.038 47.4631 70.143 47.813 69.3102L47.9536 68.9967C48.2793 68.3211 48.7188 67.7067 49.2495 67.1754L49.2485 67.1744C49.8751 66.5196 50.6284 65.9991 51.4624 65.6442L51.7778 65.5192C52.518 65.2476 53.3012 65.1099 54.0913 65.111V65.11H65.2153Z",
			fill: "#F7F7F7",
			stroke: "#F7F7F7",
			strokeWidth: 6.85367
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.0884 71.9244C52.086 71.73 52.1131 71.5365 52.1694 71.3512L52.2358 71.1686C52.3363 70.9295 52.485 70.7131 52.6724 70.5338L52.6938 70.5133L52.7153 70.4918C52.8482 70.3529 53.0007 70.2347 53.1685 70.1422L53.3413 70.0582C53.5183 69.983 53.7054 69.9355 53.896 69.9166L54.0874 69.9078H65.1499C66.0377 69.9343 66.9124 70.1328 67.7241 70.4938L67.7554 70.5084L67.7876 70.5211C68.6223 70.8428 69.3867 71.3236 70.0366 71.9381L89.0239 90.8971L89.1392 91.0123C89.2339 91.1229 89.3173 91.2425 89.3862 91.3707L89.4731 91.5514C89.5764 91.7991 89.6294 92.0652 89.6294 92.3336V92.3483C89.6313 92.5415 89.6036 92.7335 89.5474 92.9176L89.481 93.0992C89.3807 93.3366 89.2328 93.5513 89.0464 93.7291L89.0347 93.7399L89.0239 93.7516L75.9321 106.843L75.9272 106.847C75.5971 107.18 75.1638 107.387 74.7017 107.437L74.5024 107.449H74.5005C74.2427 107.452 73.9871 107.401 73.7495 107.3C73.512 107.2 73.2976 107.052 73.1196 106.866L73.0981 106.844L54.105 87.8102C53.4955 87.1849 53.017 86.4438 52.6987 85.6305L52.688 85.6012L52.6753 85.5729L52.5464 85.2633C52.2666 84.5409 52.1113 83.7755 52.0884 82.9996V71.9244Z",
			fill: "#F7F7F7",
			stroke: "#FE7933",
			strokeWidth: 2.74147
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 61.6833,
			cy: 79.5026,
			r: 4.1122,
			fill: "#F7F7F7",
			stroke: "#FE7933",
			strokeWidth: 2.74147
		})
	]
});
export default SvgIconProductImport;
